export default {
      id: "chevron-right-blue-usage",
      viewBox: "0 0 8 14",
      url: "/" + "sprite.svg#chevron-right-blue",
      toString: function () {
        return this.url;
      }
    }